(function () {
  const SELECTORS = {
    finder: '[data-pg-finder]',
    make: '[data-pg-make]',
    model: '[data-pg-model]',
    year: '[data-pg-year]',
    error: '[data-pg-finder-error]',
    home: 'main[data-template="index"]',
    transformation: '[data-pg-transformation]',
    tacomaStory: '[data-pg-tacoma-story]',
    tacomaCallout: '[data-pg-tacoma-callout]',
    gallery: '[data-pg-gallery]'
  };

  function labelFromTag(value) {
    return value.replace(/^(Make|Model|Year)_/, '').replace(/_/g, ' ');
  }

  function resetSelect(select, placeholder) {
    select.replaceChildren(new Option(placeholder, ''));
    select.disabled = true;
  }

  function addOptions(select, values) {
    values.forEach(function (value) {
      select.add(new Option(labelFromTag(value), value));
    });
    select.disabled = false;
  }

  function initFinder(finder) {
    if (finder.dataset.pgReady === 'true' || typeof window.makeObject !== 'object') return;

    const makeSelect = finder.querySelector(SELECTORS.make);
    const modelSelect = finder.querySelector(SELECTORS.model);
    const yearSelect = finder.querySelector(SELECTORS.year);
    const error = finder.querySelector(SELECTORS.error);
    if (!makeSelect || !modelSelect || !yearSelect) return;

    Object.keys(window.makeObject).forEach(function (make) {
      makeSelect.add(new Option(labelFromTag(make), make));
    });

    makeSelect.addEventListener('change', function () {
      resetSelect(modelSelect, 'Select model');
      resetSelect(yearSelect, 'Select year');
      if (makeSelect.value) addOptions(modelSelect, Object.keys(window.makeObject[makeSelect.value]));
      if (error) error.hidden = true;
    });

    modelSelect.addEventListener('change', function () {
      resetSelect(yearSelect, 'Select year');
      if (modelSelect.value) {
        addOptions(yearSelect, window.makeObject[makeSelect.value][modelSelect.value]);
      }
      if (error) error.hidden = true;
    });

    yearSelect.addEventListener('change', function () {
      if (error) error.hidden = true;
    });

    finder.addEventListener('submit', function (event) {
      event.preventDefault();
      const tags = [makeSelect.value, modelSelect.value, yearSelect.value];
      if (tags.some(function (tag) { return !tag; })) {
        if (error) {
          error.hidden = false;
          error.focus();
        }
        return;
      }

      const resultsPath = finder.dataset.resultsPath || '/collections/all';
      window.location.assign(resultsPath + '/' + tags.map(function (tag) { return encodeURIComponent(tag.toLowerCase()); }).join('+'));
    });

    finder.dataset.pgReady = 'true';
  }

  let transformationFrame;

  function updateTransformations() {
    transformationFrame = null;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const home = document.querySelector(SELECTORS.home);

    if (home && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
      home.style.setProperty('--pg-caustic-x', (Math.sin(scrollPosition / 920) * 18).toFixed(2) + 'px');
      home.style.setProperty('--pg-caustic-y', (Math.cos(scrollPosition / 760) * 14).toFixed(2) + 'px');
    }

    document.querySelectorAll(SELECTORS.transformation).forEach(function (section) {
      const rect = section.getBoundingClientRect();
      // Hold the factory-chrome frame until the sticky stage is fully in view.
      // Once the section reaches the top of the viewport, use only the remaining
      // sticky scroll distance to reveal the ChromeStoppers transformation.
      const travel = Math.max(rect.height - viewportHeight, 1);
      const progress = Math.min(Math.max(-rect.top / travel, 0), 1);
      section.style.setProperty('--pg-reveal', (progress * 100).toFixed(2) + '%');
      section.style.setProperty(
        '--pg-after-label-opacity', Math.min(Math.max((progress - 0.04) / 0.12, 0), 1).toFixed(3)
      );
      section.style.setProperty(
        '--pg-before-label-opacity', Math.min(Math.max((0.96 - progress) / 0.12, 0), 1).toFixed(3)
      );
    });

    document.querySelectorAll(SELECTORS.tacomaStory).forEach(function (section) {
      const rect = section.getBoundingClientRect();
      // Like the primary transformation, the Tacoma image settles fully into
      // its sticky stage before the trim-package story begins.
      const travel = Math.max(rect.height - viewportHeight, 1);
      const progress = Math.min(Math.max(-rect.top / travel, 0), 1);
      const revealProgress = Math.min(progress / 0.62, 1);
      const upgradedLabelOpacity = Math.min(Math.max((revealProgress - 0.04) / 0.12, 0), 1);
      const factoryLabelOpacity = Math.min(Math.max((0.96 - revealProgress) / 0.12, 0), 1);

      section.style.setProperty('--pg-tacoma-reveal', (revealProgress * 100).toFixed(2) + '%');
      section.style.setProperty('--pg-tacoma-upgraded-opacity', upgradedLabelOpacity.toFixed(3));
      section.style.setProperty('--pg-tacoma-factory-opacity', factoryLabelOpacity.toFixed(3));
      section.style.setProperty('--pg-tacoma-progress', (progress * 100).toFixed(2) + '%');

      section.querySelectorAll(SELECTORS.tacomaCallout).forEach(function (callout, index) {
        const threshold = 0.64 + index * 0.045;
        const opacity = Math.min(Math.max((progress - threshold) / 0.055, 0), 1);
        callout.style.setProperty('--pg-callout-opacity', opacity.toFixed(3));
      });
    });
  }

  function requestTransformationUpdate() {
    if (!transformationFrame) transformationFrame = window.requestAnimationFrame(updateTransformations);
  }

  function initGallery(gallery) {
    if (gallery.dataset.pgGalleryReady === 'true') return;

    gallery.querySelectorAll('[data-pg-gallery-range]').forEach(function (range) {
      range.addEventListener('input', function () {
        const frame = range.closest('.pg-gallery__compare-frame');
        if (frame) frame.style.setProperty('--pg-gallery-reveal', range.value + '%');
      });
    });

    gallery.querySelectorAll('[data-pg-gallery-dissolve]').forEach(function (button) {
      button.addEventListener('click', function () {
        const showingAfter = button.classList.toggle('is-after');
        const label = button.querySelector('[data-pg-gallery-dissolve-label]');
        button.setAttribute('aria-pressed', showingAfter ? 'true' : 'false');
        if (label) label.textContent = showingAfter ? 'Finished build · Tap for before' : 'Factory finish · Tap to transform';
      });
    });

    gallery.querySelectorAll('[data-pg-gallery-carousel]').forEach(function (carousel) {
      const track = carousel.querySelector('[data-pg-gallery-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-pg-gallery-slide]'));
      const dots = carousel.querySelector('[data-pg-gallery-dots]');
      const previous = carousel.querySelector('[data-pg-gallery-prev]');
      const next = carousel.querySelector('[data-pg-gallery-next]');
      const pause = carousel.querySelector('[data-pg-gallery-pause]');
      if (!track || slides.length === 0) return;

      let current = 0;
      let timer;
      let paused = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion;
      const speed = Number(carousel.dataset.speed) || 5000;

      function show(index, userInitiated) {
        current = (index + slides.length) % slides.length;
        track.style.transform = 'translate3d(' + (-slides[current].offsetLeft) + 'px,0,0)';
        slides.forEach(function (slide, slideIndex) {
          slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
        });
        if (dots) {
          Array.from(dots.children).forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === current);
            dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
          });
        }
        if (userInitiated) restart();
      }

      function stop() {
        window.clearInterval(timer);
        timer = undefined;
      }

      function start() {
        stop();
        if (autoplay && !paused) timer = window.setInterval(function () { show(current + 1, false); }, speed);
      }

      function restart() { stop(); start(); }

      if (dots) {
        slides.forEach(function (_, index) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Show customer photo ' + (index + 1));
          dot.addEventListener('click', function () { show(index, true); });
          dots.appendChild(dot);
        });
      }
      if (previous) previous.addEventListener('click', function () { show(current - 1, true); });
      if (next) next.addEventListener('click', function () { show(current + 1, true); });
      if (pause) {
        pause.addEventListener('click', function () {
          paused = !paused;
          pause.textContent = paused ? 'Play' : 'Pause';
          pause.setAttribute('aria-label', paused ? 'Resume rotating gallery' : 'Pause rotating gallery');
          restart();
        });
      }
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      window.addEventListener('resize', function () { show(current, false); }, { passive: true });
      show(0, false);
      start();
    });

    const galleryModal = gallery.querySelector('[data-pg-gallery-modal]') || document.querySelector('[data-pg-gallery-modal]');
    const modalGrid = galleryModal && galleryModal.querySelector('[data-pg-gallery-modal-grid]');
    const modalTitle = galleryModal && galleryModal.querySelector('[data-pg-gallery-modal-title]');
    const modalEmpty = galleryModal && galleryModal.querySelector('[data-pg-gallery-modal-empty]');

    gallery.querySelectorAll('[data-pg-gallery-group-button]').forEach(function (button) {
      const group = button.dataset.pgGalleryGroupButton;
      const groupSlides = Array.from(gallery.querySelectorAll('[data-pg-gallery-slide][data-vehicle-group="' + group + '"]'));
      const count = button.querySelector('[data-pg-gallery-group-count]');
      const countWord = button.querySelector('[data-pg-gallery-count-word]');
      if (count) count.textContent = groupSlides.length;
      if (countWord) countWord.textContent = groupSlides.length === 1 ? 'photo' : 'photos';

      button.addEventListener('click', function () {
        if (!galleryModal || !modalGrid) return;
        modalGrid.replaceChildren();
        groupSlides.forEach(function (slide) {
          const copy = slide.cloneNode(true);
          copy.removeAttribute('aria-hidden');
          copy.removeAttribute('data-pg-gallery-slide');
          copy.removeAttribute('data-shopify-editor-block');
          modalGrid.appendChild(copy);
        });
        if (modalTitle) modalTitle.textContent = button.dataset.groupLabel || 'Customer gallery';
        if (modalEmpty) modalEmpty.hidden = groupSlides.length > 0;
        if (typeof galleryModal.showModal === 'function') galleryModal.showModal();
        else galleryModal.setAttribute('open', '');
      });
    });

    if (galleryModal) {
      const closeButton = galleryModal.querySelector('[data-pg-gallery-modal-close]');
      if (closeButton) closeButton.addEventListener('click', function () { galleryModal.close(); });
      galleryModal.addEventListener('click', function (event) {
        if (event.target === galleryModal) galleryModal.close();
      });
    }

    gallery.dataset.pgGalleryReady = 'true';
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTORS.finder).forEach(initFinder);
    (root || document).querySelectorAll(SELECTORS.gallery).forEach(initGallery);
    requestTransformationUpdate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    window.addEventListener('scroll', requestTransformationUpdate, { passive: true });
    window.addEventListener('resize', requestTransformationUpdate, { passive: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
